module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_c('p', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "id": "Page_9",
      "title": "9"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "nobreak",
    attrs: {
      "id": "MY_FOUR_WEEKS_IN"
    }
  }, [_vm._v("MY FOUR WEEKS IN\nFRANCE")]), _vm._v(" "), _c('h2', {
    staticClass: "nobreak",
    attrs: {
      "id": "I"
    }
  }, [_c('span', {
    staticClass: "calibre9",
    attrs: {
      "id": "toclink_9"
    }
  }), _vm._v("I"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v(" "), _c('span', {
    staticClass: "subhead"
  }, [_vm._v("DODGING SUBMARINES TO COVER THE\nBIGGEST GAME OF ALL")])])]), _vm._v(" "), _c('h3', {
    staticClass: "calibre10",
    attrs: {
      "id": "pgepubid00002"
    }
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Wednesday, July 18. A Lake Michigan Port.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_c('span', {
    staticClass: "firstword"
  }, [_vm._v("I kept")]), _vm._v(" an appointment to-day with a gentleman\nfrom Somewhere in Connecticut.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“How,” said he, “would you like to go to\nFrance?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("I told him I’d like it very much, but that I was\nthirty-two years old, with a dependable wife and\nthree unreliable children.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Those small details,” he said, “exempt you from\nmilitary duty. But we want you as a war correspondent.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("I told him I knew nothing about war. He said it"), _c('span', {
    attrs: {
      "id": "Page_10",
      "title": "10"
    }
  }), _vm._v("\nhad frequently been proved that that had nothing to\ndo with it. So we hemmed and we hawed, pro and\ncon, till my conscientious objections were all overruled.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“In conclusion,” said he, “we’d prefer to have\nyou go on a troopship. That can be arranged\nthrough the War Department. There’ll be no\ntrouble about it.”")]), _vm._v(" "), _c('h3', {
    staticClass: "calibre10",
    attrs: {
      "id": "pgepubid00003"
    }
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Monday, July 30. A Potomac Port.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("To-day I took the matter up with the War Department,\nthrough Mr. Creel.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Mr. Creel,” I said, “can I go on a troopship?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“No,” said Mr. Creel.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("There was no trouble about it.")]), _vm._v(" "), _c('h3', {
    staticClass: "calibre10",
    attrs: {
      "id": "pgepubid00004"
    }
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Wednesday, August 1. An Atlantic Port.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("The young man in the French Consulate has\ntaken a great fancy to me. He will not visé my\npassport till I bring him two more autographed\npictures of myself.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("George W. Gloom of the steamship company said\nthere would be a ship sailing Saturday.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "id": "Page_11",
      "title": "11"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Are we convoyed through the danger zone?”\nI inquired.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“We don’t guarantee it,” said he. “There has\nnever been an accident on this line,” he added.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“What I was thinking about,” said I, “wouldn’t\nbe classed as an accident.” Further questioning\ndeveloped the comforting fact that the ship I am\ntaking has never been sunk.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("I told him I wanted a cabin to myself, as I expected\nto work.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“You will be in with two others,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“I would pay a little more to be alone,” said I.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("This evidently was not worth answering, so I\nasked him how long the trip would take.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“I know nothing about it,” said he.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“I believe that,” said I when I was well out of\nhis ear-shot.")]), _vm._v(" "), _c('h3', {
    staticClass: "calibre10",
    attrs: {
      "id": "pgepubid00005"
    }
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Wednesday, August 8. At Sea.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("We left port at ten last night, a mere three and\na half days behind schedule. The ship and I should\nbe very congenial, as we are about the same age.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("My roommates are a young man from Harvard"), _c('span', {
    attrs: {
      "id": "Page_12",
      "title": "12"
    }
  }), _vm._v("\nand a young man from Yale, but so far I have managed\nto keep the conversation neutral. We suspect\nthat they made ours a first-class cabin by substituting\nthe word 1ère for 2ème on the sign, and I am\nvery certain that my berth was designed for Rabbit\nMaranville.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Our passenger list includes a general, a congressman,\na lady novelist and her artist husband, French;\na songbird, also French; two or three majors, a\nThaw, and numerous gentlemen of the consular\nservice. The large majority on board are young\nmen going into American Ambulance and Y. M. C. A. work.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("After breakfast this morning there was life-boat\ndrill, directed by our purser, who is permanently\nmade up as Svengali. He sent us down to our\ncabins to get our life-belts and then assigned us to\nour boats. Mine, No. 12, is as far from my cabin\nas they could put it without cutting it loose from\nthe ship, and if I happen to be on deck when that\nold torpedo strikes, believe me, I’m not going to do a\nMarathon for a life-belt. Shoes off, and a running\nhop, step and jump looks like the best system."), _c('span', {
    attrs: {
      "id": "Page_13",
      "title": "13"
    }
  }), _vm._v("\nMoreover, I’m going to disobey another of the rules,\nwhich is that each passenger must remain calm.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Next we had to fill out a form for the enlightenment\nof Svengali as to our destination, business,\nhome address, foreign address, literary tastes, etc.\nOne item was “the names of relatives or friends\nyou lofh.” This was unanswered, as nobody aboard\nseemed to know the meaning of the verb.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("In the fumoir this afternoon a young American\nwanted a match. He consulted his dictionary and\ndug out “allumette.” But he thought the t’s were\nsilent and asked Auguste for “allumay.” Auguste\ndisappeared and returned in five minutes with a\nlarge glass of lemonade. The cost of that little\nFrench lesson was two francs.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("I am elected to eat at the “second table.” Our\nbunch has luncheon at twelve-thirty and dinner at\nseven. The first table crowd’s hours are eleven and\nfive-thirty. Breakfast is a free-for-all and we sit\nwhere we choose. My trough mates at the meals\nare two Americans, a Brazilian, and four Frenchmen.\nOurs is a stag table, which unfortunate circumstance\nis due to the paucity of women, or, as"), _c('span', {
    attrs: {
      "id": "Page_14",
      "title": "14"
    }
  }), _vm._v("\nthey are sometimes called, members of the fair sex.\nThe Brazilian speaks nine or ten languages, but\nseems to prefer French. The two Americans are\nalways engaged in sotto voce dialogue, and the four\nFrenchmen race with the Brazilian for the conversational\nspeed championship of the high seas. This\nleaves me free to devote all my time to the proper\nmastication of food.")]), _vm._v(" "), _c('h3', {
    staticClass: "calibre10",
    attrs: {
      "id": "pgepubid00006"
    }
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Thursday, August 9. Completely at Sea.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("A gentleman on board is supplied with one of\nthese newfangled one hundred dollar safety suits.\nThe wearer is supposed to be able to float indefinitely.\nIt is also a sort of thermos bottle, keeping\none warm in cold water and cool in hot. I do not\nenvy the gent. I have no ambition to float indefinitely.\nAnd if I didn’t happen to have it on when\nthe crash came, I doubt whether I could spare the\ntime to change. And besides, if I ever do feel that\nI can afford one hundred dollars for a suit, I won’t\nwant to wear it for the edification of mere fish.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("When Svengali isn’t busy pursing, he is usually"), _c('span', {
    attrs: {
      "id": "Page_15",
      "title": "15"
    }
  }), _vm._v("\nengaged in chess matches with another of the officers.\nThe rest of the idle portion of the crew stand\nround the table and look on. Sometimes they look\non for an hour without seeing a move made, but\nthey never seem to lose interest. Every little movement\nbrings forth a veritable torrent of français\nfrom the spectators. I can understand the fascination\nof chess from the player’s end, but could get\nfew thrills from watching, especially when there\nwas standing room only.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Far more fascinating to look at is the game two\nof my French trough mates play at breakfast. The\nrules are simple. You take a muffin about the size\nof a golf ball. You drop it into your cup of chocolate.\nThen you fish for it, sometimes with a spoon,\nbut more often with your fingers. The object is to\nconvey it to your mouth without discoloring your\nnecktie. Success comes three times in five.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("The players are about evenly matched. One of\nthem I suspect, is not in the game for sport’s sake,\nbut has a worthier object. Nature supplied him\nwith a light gray mustache, and a chocolate brown"), _c('span', {
    attrs: {
      "id": "Page_16",
      "title": "16"
    }
  }), _vm._v("\nwould blend better with his complexion. If the\nmuffins hold out, his color scheme will be perfect before\nwe reach port.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("The discovery has been made that there’s a man\non board who plays the cornet, so if we are subbed\nit will not be an unmitigated evil.")]), _vm._v(" "), _c('h3', {
    staticClass: "calibre10",
    attrs: {
      "id": "pgepubid00007"
    }
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Friday, August 10.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Every morning one sees on the deck people one\nnever saw before, and as we have not stopped at\nany stations since we started, the inference is that\ncertain parties have not found the trip a continuous\njoy ride.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("A news bulletin, published every morning, sometimes\nin English and sometimes in French, keeps\nus right up to date on thrilling events, thrillingly\nspelled. I have copied a sample:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquot"
  }, [_c('p', {
    staticClass: "calibre8"
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("It is now the tim for the final invaseon of the west\nby the eastren american league teams and before\nthis clash is over it will be definitively known wether\nthe two sox teams are to fight it out in a nip and tuk\nfinish or wether the Chicago sox will have a comfortable\nmargen to insure a world series betwean the two\nlargest American citys Chicago and New York.")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "id": "Page_17",
      "title": "17"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("The French news deals exclusively with the developments\nin the world series Over There, which\nis, perhaps, almost as important.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("A new acquaintance made to-day was that of the\nGentleman from Louisiana. He introduced himself\nto scold me and another guy for not taking sufficient\nexercise. We told him we found little pleasure\nin promenading the deck.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“That’s unnecessary,” he said. “Get yourselves\na pair of three-pound dumb-bells and use them a\ncertain length of time every day.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("So we are constantly on the lookout for a dumb-bell\nshop, but there seems to be a regrettable lack\nof such establishments in mid-ocean.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("The Gentleman from Louisiana says he is going\nto join the Foreign Legion if they’ll take him. He\nis only seventy years old.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“But age makes no difference to a man like I,”\nsays he. “I exercise and keep hard. All my friends\nare hard and tough. Why, one of my friends, an\nundertaker, always carries a razor in his boot.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Presumably this bird never allows psychological\ndepression in his business.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "id": "Page_18",
      "title": "18"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("The Gentleman from Louisiana continues:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“I’ve got a reputation for hardness, but I’m only\nhard when I know I’m right. I used such hard\nlanguage once that they injected me from a committee.\nI was state senator then. But in all the\ntime I held office I never talked more than two\nminutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("We expressed polite regret that he was not a\nstate senator still. And we asked him to have a\nlemonade.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“No, thank you. Even the softest drinks have a\npeculiar effect on me. They make my toes stick\ntogether.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("We guaranteed to pry those members apart again\nafter he had quenched his thirst, but he would not\ntake a chance.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("On the way cabinward from this fascinating presence,\nI was invited into a crap game on the salle à\nmanger floor. The gentleman with the dice tossed\na hundred-franc note into the ring and said: “Shoot\nit all.” And the amount was promptly oversubscribed.\nSo I kept on going cabinward.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "id": "Page_19",
      "title": "19"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "calibre10",
    attrs: {
      "id": "pgepubid00008"
    }
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Samedi, 11 Août.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("The man back there in the steamship office can no\nmore truthfully say: “There has never been an\naccident on this line.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("I awoke at three-thirty this morning to find the\ncabin insufferably hot and opened the port-hole\nwhich is directly above my berth. The majority of\nthe ocean immediately left its usual haunts and came\nindoors. Yale and Harvard were given a shower\nbath and I had a choice of putting on the driest\nthings I could find and going on deck or drowning\nwhere I lay. The former seemed the preferable\ncourse.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Out there I found several fellow voyagers asleep\nin their chairs and a watchman in a red-and-white\ntam-o’-shanter scanning the bounding main for old\nHans W. Periscope.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("I wanted sympathy, but the watchman informed\nme that he ne comprended pas anglais, monsieur.\nSo we stood there together and scanned, each in his\nown language.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "id": "Page_20",
      "title": "20"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("My garçon de cabine promises he will have me\nthoroughly bailed out by bedtime to-night.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("I sat at a different breakfast table, but there was\nno want of entertainment. At my side was a master\nof both anglais and français, and opposite him an\nAmerican young lady who thinks French is simply\njust impossible to learn.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Mademoiselle,” says he, “must find it difficult to\nget what she likes to eat.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“I certainly do,” says she. “I don’t understand a\nword of what’s on the menu card.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Perhaps I can help mademoiselle,” says he.\n“Would she like perhaps a grapefruit?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("She would and she’d also like oatmeal and eggs\nand coffee. So he steered her straight through the\nmeal with almost painful politeness, but in the intervals\nwhen he wasn’t using his hands as an aid to\ngallant discourse, he was manicuring himself with\na fork.")]), _vm._v(" "), _c('div', {
    staticClass: "figcenter1",
    attrs: {
      "id": "il_2"
    }
  }, [_c('img', {
    staticClass: "calibre4",
    attrs: {
      "alt": " ",
      "id": "id-1172183580308778439",
      "src": "OEBPS/Images/3757041487943700252_i_020.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_vm._v("The majority of the ocean immediately left its usual haunts and came indoors\n")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("This afternoon they drug me into a bridge game.\nMy partner was our congressman’s secretary. Our\nopponents were a Standard Oil official and a vice-consul\nbound for Italy. My partner’s middle name"), _c('span', {
    attrs: {
      "id": "Page_21",
      "title": "21"
    }
  }), _vm._v("\nwas Bid and Mr. Oil’s was Double. And I was too\nshy to object when they said we’d play for a cent a\npoint.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("At the hour of going to press, Standard Oil had\npractically all the money in the world. And my\npartner has learned that a holding of five clubs\ndoesn’t demand a bid of the same amount.")]), _vm._v(" "), _c('h3', {
    staticClass: "calibre10",
    attrs: {
      "id": "pgepubid00009"
    }
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Sunday, August 12.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("The boat seems to be well supplied with the\nnecessities of life, such as cocktails and cards and\nchips, but it is next to impossible to obtain luxuries\nlike matches, ice-water and soap.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Yale and Harvard both knew enough to bring\ntheir own soap, but my previous ocean experiences\nwere mostly with the Old Fall River Line, on which\nthere wasn’t time to wash. Neither Yale nor Harvard\never takes a hint. And “Apportez-moi du\nsavon, s’il vous plaît,” to the cabin steward is just\nas ineffectual.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("All good people attended service this morning,\nand some bad ones played poker this afternoon.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("In a burst of generosity I invited a second-class"), _c('span', {
    attrs: {
      "id": "Page_22",
      "title": "22"
    }
  }), _vm._v("\nFrench young lady of five summers to have some\ncandy. She accepted, and her acceptance led to\nthe discovery that the ship’s barber is also its candy\nsalesman.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("This barber understands not a syllable of English,\nwhich fact has added much to young America’s\nenjoyment. The boys, in the midst of a hair\ncut, say to him politely: “You realize that you’re\na damn rotten barber?” And he answers smilingly:\n“Oui, oui, monsieur.” Yesterday, I am told, a\nyoung shavee remarked: “You make me sick.”\nThe barber replied as usual, and the customer was\nsick all last night.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("To-morrow afternoon there is to be a “concert”\nand I’m to speak a piece, O Diary!")]), _vm._v(" "), _c('h3', {
    staticClass: "calibre10",
    attrs: {
      "id": "pgepubid00010"
    }
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Monday, August 13.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("The concert was “au profit du Secours National\nde France. Œuvre fondée pour répartir les Secours\naux Victimes de la Guerre.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Ten minutes before starting time they informed\nme that I was to talk on “The American National\nGame,” and I don’t even know how the White Sox\ncame out a week ago to-morrow.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "id": "Page_23",
      "title": "23"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("The afternoon’s entertainment opened with a few\nwell-chosen remarks by our congressman. The general,\ndesignated on the program as “chairman,”\nthough his real job was toastmaster, talked a while\nabout this, that and the other thing, and then introduced\nthe cornet player, using his real name.\nThis gentleman and I blew at the same time, so I\nhave no idea what he played. I got back in time for\nsome pretty good harmonizing by three young\nAmericans and a boy from Cincinnati. Then there\nwas a Humorous Recitation (the program said so)\nby a gent with a funny name, and some really delightful\nFrench folk songs by the lady novelist.\nAfter which came a Humorous Speech (the program\nforgot to say so) by myself, necessarily brief,\nas I gave it in French. The French songbird followed\nwith one of those things that jump back and\nforth between Pike’s Peak and the Grand Cañon,\nand a brave boy played a ukelele, and the quartette\nrepeated. In conclusion, we all rose and attempted\n"), _c('i', {
    staticClass: "calibre6",
    attrs: {
      "lang": "fr"
    }
  }, [_vm._v("La Marseillaise")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Some of the programs had been illustrated by the\nlady novelist’s artist husband, and these were auctioned"), _c('span', {
    attrs: {
      "id": "Page_24",
      "title": "24"
    }
  }), _vm._v("\noff after the show. I made my financial contribution\nindirectly, through better card players\nthan myself. My bridge partner, I noticed, had\nrecovered from his attack of the Bids.")]), _vm._v(" "), _c('h3', {
    staticClass: "calibre10",
    attrs: {
      "id": "pgepubid00011"
    }
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Tuesday, August 14.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("The concert, by the way, was given in the salon\nde conversation, which, I think, should be reserved\nfor the Gentleman from Louisiana. He has now\ntold me two hundred times that he won his election\nto the State Senate by giving one dollar and a half\nto “a nigger.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("One of our young field-service men spoiled the\nforenoon poker game with a lecture on how to catch\nsharks. His remarkable idea is to put beefsteak on\na stout copper wire and troll with it. He has evidently\nbeen very intimate with this family of fish,\nand he says they are simply crazy about beefsteak.\nPersonally, I have no desire to catch sharks. There\nare plenty aboard. But I do wish he had not got\nto the most interesting part of his theory at the\nmoment the dealer slipped me four sixes before the\ndraw. Everybody was too busy listening to stay.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "id": "Page_25",
      "title": "25"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("We have discovered that the man behind the gun\nin the fumoir bears a striking resemblance to Von\nHindenburg, but no one has been found who will tell\nhim so.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("There was a track meet this afternoon, and the\nauthor of this diary was appointed referee. But\nthe first event, a wheelbarrow race, was so exciting\nthat he feared for his weak heart and resigned in\nfavor of our general. There didn’t seem to be much\nelse to the meet but ju-jutsu, the sport in which\nskill is supposed to triumph over brawn. I noticed\nthat a two-hundred-and-thirty-pound man was the\nwinner.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("We are in that old zone, and the second table’s\ndinner hour has been advanced to half past six so\nthat there need be no lights in the dining-room.\nAlso, we are ordered not to smoke, not even to light\na match, on deck after dark. The fumoir will be\nrunning for the last time, but the port-holes in it\nwill all be sealed, meaning that after thirty-five\nsmokers have done their best for a few hours the\natmosphere will be intolerable. We can stay on\ndeck smokeless, or we can try to exist in the airless"), _c('span', {
    attrs: {
      "id": "Page_26",
      "title": "26"
    }
  }), _vm._v("\nfumoir, or we can go to bed in the dark and wish\nwe were sleepy. And the worst is yet to come.")]), _vm._v(" "), _c('h3', {
    staticClass: "calibre10",
    attrs: {
      "id": "pgepubid00012"
    }
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Wednesday, August 15.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("The rules for to-night and to-morrow night provide\nfor the closing of our old friend, the fumoir,\nat seven o’clock, and that witching hour is on you\nlong before you expect it, for they jump the clock\nfifteen minutes ahead every time it’s noon or midnight.\nThe ship will not be lit up. The passengers\nmay, if they do their shopping early.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("There was another life-boat “drill” this afternoon.\nEvery one was required to stand in front of\nhis canoe and await the arrival of Svengali. When\nthat gent appeared, he called the roll. As soon as\nyou said “Here” or “Present,” your part of the\n“drill” was over. When the time comes I must do\nmy drifting under an alias, as Svengali insists on\ndesignating me as Monsieur Gardnierre. But No.\n12 is at least honored with two second-class ladies.\nMany a poor devil on the ship is assigned to a life-boat\nthat is strictly stag.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("The Gentleman from Louisiana to-day sprang\nthis one:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "id": "Page_27",
      "title": "27"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“You know when I part my hair in the middle I\nlook just like a girl. Well, sir, during the Mardi\nGras, two years ago, I put on a page’s costume and\nparted my hair in the middle. And you know girls\nunder a certain age must go home at nine o’clock\nin the evening. Well, sir, a policeman accosted me\nand told me I had to go home. I gave him the bawling\nout of his life. And maybe you think he wasn’t\nsurprised!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Maybe I do think so.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("The Gentleman strayed to the subject of Patti\nand wound up with a vocal imitation of that lady.\nHe stopped suddenly when his voice parted in the\nmiddle.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("We have seen no periscopes, but when I opened\nmy suit-case this morning I met face to face one\nof those birds that are house pets with inmates of\nseven-room flats at twenty-five dollars per month.\nI missed fire with a clothes brush, and before I could\naim again he had submerged under a vest. Looks\nas if the little fellow were destined to go with me to\nParis, but when I get him there I’ll get him good.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "id": "Page_28",
      "title": "28"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "calibre10",
    attrs: {
      "id": "pgepubid00013"
    }
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Thursday, August 16.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Great excitement last night when a small unlighted\nboat was sighted half a mile or so off our\nport. Our gunners, who are said to receive a bonus\nfor every effective shot, had the range all figured\nout when the pesky thing gave us a signal of friendship.\nIt may have been part of the entertainment.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("To-day we persuaded the Gentleman from Louisiana\nto part his hair in the middle. The New\nOrleans policeman is not guilty.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("It develops that while first- and second-class passengers\nwere unable to read or smoke after dark,\nthe third-class fumoir is running wide open and the\nGreeks have their cigarettes, libations and card\ngames, while the idle rich bore one another to death\nwith conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Un Américain aboard is now boasting of the\nworld’s championship as a load carrier. It was too\nmuch trouble for him to pay Auguste for each\nbeverage as it was served, so he ran a two days’\ncharge account. His bill was one hundred and"), _c('span', {
    attrs: {
      "id": "Page_29",
      "title": "29"
    }
  }), _vm._v("\nseventy-eight francs, or thirty-five dollars and sixty\ncents.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Who got all the drinks?” he asked Auguste.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“You, monsieur,” that gent replied.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“And what do you charge for a highball?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“One franc, monsieur,” said Auguste.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Which means, if Auguste is to be believed, that\none hundred and seventy-eight highballs went down\none throat in two days. And the owner of the\nthroat is still alive and well. Also, he says he will\nhereafter pay as you enter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("As an appetizer for dinner to-night the captain\ntold everybody to remain on deck, fully dressed and\narmed with a life-belt, this evening, until he gave\npermission to retire.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("We’re all on deck, and in another minute it will\nbe too dark to write.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("To-morrow night, Boche willing, we will be out\nof the jurisdiction of this Imp of Darkness.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15a4441c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Section007.vue
// module id = 66
// module chunks = 0